const self = {
  verbose: process.env.NODE_ENV != 'production',
  log: function (msg) {
    if (true || self.verbose) console.log(msg)
  }
}
module.exports = self



// WEBPACK FOOTER //
// ./src/utils/logger.js